import { Injectable } from '@angular/core';
import { LocalStorageService } from '@viso/core/data-access';
import { count } from 'rxjs';

const REGISTRATION_DETAILS = 'registration-details';

@Injectable({
  providedIn: 'root',
})
export class RegistrationDetailsService {
  constructor(private storage: LocalStorageService) {}

  saveRegistrationDetails(value) {
    const stringified = JSON.stringify(value);
    this.storage.set(REGISTRATION_DETAILS, stringified);
  }

  clearRegistrationDetails() {
    const {phone} = this.getRegistrationDetails();
    this.saveRegistrationDetails({phone});
  }

  getRegistrationDetails() {
    const storedFormValue = this.storage.get(REGISTRATION_DETAILS);
    const formValue =
      !storedFormValue || storedFormValue == 'null' || storedFormValue == ''
        ? {}
        : JSON.parse(storedFormValue);
    return formValue;
  }

  getPhoneNumber() {
    const value = this.getRegistrationDetails();
    return value.phone;
  }

  getCountryCode() {
    const value = this.getRegistrationDetails();
    if (value.country_code === undefined){
      return "91";
    } else {
      return value.country_code.replace("+","");
    }
  }
}
